export default __webpack_public_path__ + "static/media/dooh_evenly.311703cd.svg";